import { toast } from './toast'
import { get, forOwn, has } from 'lodash'
import io from 'socket.io-client'
import EventEmitter from 'events'

let socket
export const socketEventEmitter = new EventEmitter()
export const socketEvents = {
  poheadercreated: 'poheadercreated',
  pocreated: 'pocreated',
  pdfitemcreated: 'pdfitemcreated',
  pdfitemcreateerror: 'pdfitemcreateerror',
  poidentifiersupdateerror: 'poidentifiersupdateerror',
}

const isValidEventName = name => has(socketEvents, name)

const showSuccessToast = (message) => {
  toast({
    type: 'success',
    title: 'Success',
    description: get(message, "message.status")
  })
}

const showErrorToast = (message) => {
  toast({
    type: 'error',
    title: 'Error',
    description: get(message, "message.status")
  })
}

// initializeSocket(userName, reset)
// initialize socket.io client
// returns 'false' if the socket is already initialized
// return 'true' if the socket was initialized by the current function call
// if reset is 'true' it will destroy the current instance and create it again
export const initializeSocket = (userName, reset = false) => {
  if (reset) {
    destroySocket()
    return initializeSocket(userName)
  }

  if (socket) {
    return false
  }

  const loc = window.location
  let location = `${loc.protocol}//${loc.hostname}`
  if (loc.port !== '') {
    location = location + ':' + loc.port
  }

  socket = io(location, {
    transports: ['websocket'],
    upgrade: false
  })

  socket.on('connect', () => {
    console.log('Connected to server', userName)
    socket.emit('userConnected', userName)
  })

  socket.on('workflowMessage', (message) => {
      const eventName = get(message, 'message.statusCode')
      if (get(message, 'message.isError')) {
        showErrorToast(message)
      } else {
        showSuccessToast(message);
      }

      if (isValidEventName(eventName)) {
        socketEventEmitter.emit(eventName)
      }
    }
  );

  socket.on('currentUsers', function (message) {
    console.log('currentUsers', message)
  })

  return true
}

export const destroySocket = () => {
  if (socket) {
    socket.disconnect()
    socket = void 0
    forOwn(socketEvents, (_, k) => socketEventEmitter.removeAllListeners(k))
  }
}



// WEBPACK FOOTER //
// ./utilities/socketioClient.js